import React from "react";
import Auth from "../Pages/Auth";
import Home from "../Pages/home";
import Formlist from "../Pages/formlist";
import EditForm from "../Pages/editForm";

import { ProtectedRoute } from "./ProtectedRoute";
import PreviewForm from "../Pages/PreviewForm";
import ViewForm from "../Pages/ViewForm";
import EditCount from "../Pages/EditCount";
import Reports from "../Pages/Reports";

const Routepath = [
  {
    path: "/",
    element: <Auth />,
  },
  {
    path: "/Home",
    element: (
      <ProtectedRoute>
        <Home />
      </ProtectedRoute>
    ),
  },
  {
    path: "/Formlist",
    element: (
      <ProtectedRoute>
        <Formlist />
      </ProtectedRoute>
    ),
  },
  {
    path: "/EditForm/:id",
    element: (
      <ProtectedRoute>
        <EditForm />
      </ProtectedRoute>
    ),
  },
  {
    path: "/PreviewForm",
    element: (
      <ProtectedRoute>
        <PreviewForm />
      </ProtectedRoute>
    ),
  },
  {
    path: "/EditCount/:id",
    element: (
      <ProtectedRoute>
        <EditCount />
      </ProtectedRoute>
    ),
  },
  {
    path: "/EditForm/:id",
    element: (
      <ProtectedRoute>
        <EditForm />
      </ProtectedRoute>
    ),
  },
  {
    path: "/Form/:id",
    element: <ViewForm />,
  },
  {
    path: "/Reports",
    element: (
      <ProtectedRoute>
        <Reports />
      </ProtectedRoute>
    ),
  },
];

export default Routepath;
